export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div>
            <span className="text-xl md:text-2xl font-heading text-background-50 tracking-wide">
              迷妹漫画
            </span>
            <p className="mt-3 text-xs md:text-sm text-background-400 leading-relaxed">
              迷妹漫画网专注聚合漫画全集与完结漫画完整版资源，提供完结漫画大全一站式在线浏览，支持竖屏连续滚动阅读，让漫画迷一次性补完大结局。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '完结漫画专题', href: '#carousel' },
                { label: '精选推荐', href: '#cards' },
                { label: '完结漫画分类', href: '#index' },
                { label: '视频专区', href: '#media' },
                { label: '完结漫画风云榜', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                    className="text-xs md:text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门话题</h4>
            <ul className="space-y-2">
              {['完结漫画大全', '漫画全集', '下拉式漫画', '免费漫画推荐', '完结日漫', '完结国漫'].map((item) => (
                <li key={item}>
                  <a
                    href="#topics"
                    onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
                    className="text-xs md:text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-semibold text-background-50 mb-2">关注我们</h4>
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-background-700 flex items-center justify-center text-background-300 cursor-pointer hover:bg-background-600 transition-colors">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                <span className="w-8 h-8 rounded-lg bg-background-700 flex items-center justify-center text-background-300 cursor-pointer hover:bg-background-600 transition-colors">
                  <i className="ri-weibo-line text-sm"></i>
                </span>
                <span className="w-8 h-8 rounded-lg bg-background-700 flex items-center justify-center text-background-300 cursor-pointer hover:bg-background-600 transition-colors">
                  <i className="ri-bilibili-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2026 迷妹漫画网 - 完结漫画大全，漫画全集在线免费下拉式阅读
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); scrollTo('#about'); }}
                className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                关于我们
              </a>
              <a
                href="#faq"
                onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }}
                className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                常见问题
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
                className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}